import {Link} from "react-router-dom";
import {getStatusName} from "../../utils/tools";
import dateFormat from "dateformat";
import React from "react";
import TableData from "../../components/tables";

export class ConsultationTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dataSearch: this.props.dataSearch,
            entity: this.props.entity
        };
    }

    render() {
        const columns = [
            {
                Header: "Date du RDV",
                accessor: "start_at",
                maxWidth: 300,
                className: "text-left",
                Cell: row => (
                    <Link to={'/consultations/details/' + row.original.id}>
                        <span className="table__filter__practitioner">
                            { dateFormat(new Date(row.original.start_at), "dd/mm/yyyy HH:MM")}
                        </span>
                    </Link>
                )
            },
            {
                Header: "Statut",
                accessor: "name",
                className: "text-center",
                Cell: row => (
                    <span className="table__filter__practitioner">{ getStatusName(row.original.status)}</span>
                )
            }
        ];

        let practitionerColumn = {
            Header: "Praticien",
            accessor: "first_name",
            maxWidth: 300,
            className: "text-left",
            Cell: row => (
                <Link to={'/consultations/details/' + row.original.id}>
                    <div
                        className="d-inline-block item-icon-wrapper table__filter__practitioner"
                    />
                    <span className="table__filter__practitioner">{row.original.practitioner.first_name + ' ' + row.original.practitioner.last_name}</span>
                </Link>
            ),
        };

        let patientColumn = {
            Header: "Patient",
            accessor: "id",
            maxWidth: 300,
            className: "text-left",
            Cell: row => (
              <Link to={'/consultations/details/' + row.original.id}>
                  <div
                    className="d-inline-block item-icon-wrapper table__filter__practitioner"
                  />
                  <span className="table__filter__practitioner">{row.original.patient ? row.original.patient.first_name + ' ' + row.original.patient.last_name : row.original.email}</span>
              </Link>
            ),
        };

        if (this.state.entity === 'patient') {
            columns.splice(1, 0, practitionerColumn);
        } else if (this.state.entity === 'practitioner') {
            columns.splice(1, 0, patientColumn);
        } else {
            columns.splice(1, 0, practitionerColumn, patientColumn);
        }

        return (
            <TableData
                parent={this.props.parent}
                research={this.props.research}
                tableData="consultations"
                dataColumns={columns}
                title={"Liste des consultations"}
                dataSearch={this.state.dataSearch}
                selected={this.props.selected}
                dataName={'appointments'}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/tables/ConsultationTable.js